import * as React from 'react';

import { ResidenceCardData } from 'features/search/types';
import { HeadlineLevel } from 'features/ui/enums';
import {truncate} from 'features/services/utils/string-helpers';

import { ContentTemplate } from './_contentTemplate';

interface Props {
    residence: ResidenceCardData;
    level?: HeadlineLevel;
}

export const ReferenceContent: React.FunctionComponent<Props> = ({ residence, level }) => {
    return (
        <ContentTemplate 
            residenceData={residence} 
            headline={residence.name}
            description={residence.text ? truncate(residence.text, 10) : ''}
            level={level}
        />
    )
}